/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconListSearch = createReactComponent("outline", "list-search", "IconListSearch", [["path", { "d": "M15 15m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-0" }], ["path", { "d": "M18.5 18.5l2.5 2.5", "key": "svg-1" }], ["path", { "d": "M4 6h16", "key": "svg-2" }], ["path", { "d": "M4 12h4", "key": "svg-3" }], ["path", { "d": "M4 18h4", "key": "svg-4" }]]);

export { IconListSearch as default };
//# sourceMappingURL=IconListSearch.mjs.map
